import { render } from "./About.vue?vue&type=template&id=66b8efd3"
const script = {}
script.render = render

export default script